import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
  qualityValues,
} from "@redotech/redo-model/ai-context-library";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const SchemaTypeValues = Object.values(SchemaType) as [
  SchemaType,
  ...SchemaType[],
];

export const createContextLibraryItem = {
  name: "createContextLibraryItem" as const,
  input: z.object({
    type: z.literal(AiContextLibraryType.MARKETING),
    title: z.string(),
    content: z.string(),
    triggerType: createEnum(SchemaTypeValues),
    strategy: z.string().optional(),
    scenarioType: z.string().optional(),
    channel: createEnum(AutomationChannelValues),
    quality: createEnum(qualityValues),
    feedback: z.string().optional(),
  }),
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
